import { createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';

const CONSOLE_MAX_CHARS = 5000;

export const debugSlice = createSlice({
    name: 'debug',
    initialState: {
        projectId: undefined,
        socket: undefined,
        connected: false,
        progress: 0,
        devices: [],
        device: undefined,
        uploadMethod: undefined,
        console: [],
        consoleHistory: '',
        variables: {},
        debugState: '',
        firmwareUploadState: '',
        networks: [],
        selectedNetwork: 'localhost',
        binary: undefined,
        deviceDashboardRequests: {},
        breakpoints: {}, // { [file]: [line, line, line] }
        blockBreakpoints: [], //
        currentBlockBreakpoint: undefined,
        showFirmwareDownload: false,
        serialPort: undefined,
        debugPanelSelectedTab: 'console',
        runMode: '', // empty string for normal run mode, 'simulator' for simulator mode
        debuggerStop: undefined, // {file: filenam, line: line}
        blockHighlights: {}, // { [featureId]: Date.now() }
    },
    reducers: {
        debuggerInit: (state, action) => {
            state.projectId = action.payload;
            state.breakpoints = {};
            state.blockBreakpoints = [];
            state.debuggerStop = undefined;
        },
        debuggerClose: (state, action) => { },
        debuggerDeviceBuzz: (state, action) => { },
        debuggerRefresh: (state, action) => { },
        debuggerDeviceReboot: (state, action) => { },
        debuggerDevicePause: (state, action) => { },
        debuggerDeviceRestartDebug: (state, action) => { },
        debuggerDeviceStartDebug: (state, action) => { },
        debuggerVariablesGetAll: (state, action) => { },
        debuggerVariableGet: (state, action) => { },
        debuggerVariableSet: (state, action) => { },
        debuggerDeviceLogin: (state, action) => { },
        debuggerSetPassword: (state, action) => { },
        debuggerTaskStop: (state, action) => { },
        debuggerUploadApplication: (state, action) => { },
        debuggerStop: (state, action) => { },
        debuggerDownloadRelease: (state, action) => { },
        debuggerDownloadTcu: (state, action) => { },
        debuggerSaveTcu: (state, action) => { },
        debuggerDownloadTcuFromServer: (state, action) => { },
        debuggerUploadRelease: (state, action) => { },
        debuggerUploadFirmware: (state, action) => { },
        debuggerSaveFirmware: (state, action) => { },
        debuggerDebugStart: (state, action) => { },
        debuggerSetSerialBaud: (state, action) => {
            state.serialPort = {
                ...state.serialPort,
                baudRate: action.payload,
            };
        },
        debuggerAttachSerial: (state, action) => { },
        debuggerSetSerialPort: (state, action) => {
            if (action.payload && action.payload.port) {
                state.serialPort = {
                    ...state.serialPort,
                    port: action.payload.port,
                };
            }
        },
        debuggerDetachSerial: (state, action) => {
            state.serialPort = {
                ...state.serialPort,
                port: undefined,
            };
        },
        debuggerReleaseUpload: (state, action) => { },
        debuggerFirmwareUpload: (state, action) => { },
        deviceDashboardProxyHttpRequest: (state, action) => { },
        setDevices: (state, action) => {
            state.devices = action.payload;
        },
        setProgress: (state, action) => {
            state.progress = action.payload;
        },
        setConnected: (state, action) => {
            state.connected = action.payload;
        },
        setUploadMethod: (state, action) => {
            state.uploadMethod = action.payload;
        },
        setDevice: (state, action) => {
            if (!action.payload) {
                state.device = undefined;
                return;
            }
            let firmware = '';
            let platform = '';
            const payload = {
                ...action.payload,
            };
            if (action.payload.type === 'tios'
                && action.payload.tios.indexOf('TiOS-32 Loader') < 0) {
                platform = action.payload.tios.split('-')[0].substring(1);
                firmware = action.payload.tios.split('-')[1];
                firmware = firmware.substring(0, firmware.length - 1);
            } else {
                platform = '';
                firmware = action.payload.tios;
            }
            if (action.payload.type === 'serial') {
                if (!action.payload.baudRate) {
                    payload.baudRate = 115200;
                }
            }
            state.device = {
                platform,
                firmware,
                ...state.device,
                ...payload,
            };
            if (!payload.streamURL) {
                delete state.device.streamURL;
            }
        },
        setDebugState: (state, action) => {
            state.debugState = action.payload;
        },
        setRunMode: (state, action) => {
            state.runMode = action.payload;
        },
        simulatorSendEvent: (state, action) => {

        },
        clearConsole: (state, action) => {
            return {
                ...state,
                console: [],
                consoleHistory: '',
            };
        },
        addToConsole: (state, action) => {
            return {
                ...state,
                console: [
                    ...state.console,
                    {
                        time: new Date().getTime() + (Math.floor(Math.random() * 10000)),
                        data: action.payload,
                    },
                ],
            };
        },
        setConsole: (state, action) => {
            return {
                ...state,
                console: [
                    ...state.console,
                    {
                        time: new Date().getTime() + (Math.floor(Math.random() * 10000)),
                        data: action.payload,
                    },
                ],
                consoleHistory: '',
            };
        },
        removeFromConsole: (state, action) => {
            let consoleHistory = state.consoleHistory;
            const size = state.consoleHistory.length;
            if (size > CONSOLE_MAX_CHARS) {
                let lines = state.consoleHistory.split('\n');
                lines = lines.slice(lines.length - 50);
                consoleHistory = lines.join('\n');
            }
            return {
                ...state,
                console: [],
                consoleHistory: consoleHistory + action.payload.data,
            };
        },
        addDevice: (state, action) => {
            let firmware = '';
            let platform = '';
            if (action.payload.tios.indexOf('TiOS-32 Loader') < 0
                && action.payload.type === 'tios') {
                platform = action.payload.tios.split('-')[0].substring(1);
                firmware = action.payload.tios.split('-')[1];
                firmware = firmware.substring(0, firmware.length - 1);
            } else {
                platform = '';
                firmware = action.payload.tios;
            }
            const device = {
                ...action.payload,
                firmware,
                platform,
            };
            let found = false;
            for (let i = 0; i < state.devices.length; i++) {
                if (device.mac === state.devices[i].mac) {
                    state.devices[i] = {
                        ...state.devices[i],
                        ...device,
                    };
                    found = true;
                    break;
                }
            }
            if (!found) {
                state.devices.push(device);
            }
        },
        setVariable: (state, action) => {
            state.variables = {
                ...state.variables,
                [action.payload.name]: action.payload.value,
            };
        },
        debuggerSetBinary: (state, action) => {
            state.binary = action.payload;
        },
        setNetworks(state, action) {
            return {
                ...state,
                networks: action.payload,
            };
        },
        setSelectedNetwork(state, action) {
            return {
                ...state,
                selectedNetwork: action.payload,
            };
        },
        setDeviceDashboardRequests: (state, action) => {
            const { deviceDashboardRequests } = state;
            if (deviceDashboardRequests[action.payload.nonce] === undefined) {
                deviceDashboardRequests[action.payload.nonce] = { ...action.payload };
            } else {
                deviceDashboardRequests[action.payload.nonce] = {
                    ...deviceDashboardRequests[action.payload.nonce],
                    response: action.payload.response,
                };
            }
            state = {
                ...state,
                deviceDashboardRequests: {
                    ...deviceDashboardRequests,
                },
            };
        },
        clearDeviceDashboardRequests: (state, action) => {
            const { deviceDashboardRequests } = state;
            delete deviceDashboardRequests[action.payload.nonce];
            state = {
                ...state,
                deviceDashboardRequests,
            };
        },
        setBreakpoints: (state, action) => {
            return {
                ...state,
                breakpoints: {
                    ...action.payload,
                },
            };
        },
        toggleBreakpoint: (state, action) => {
            const { file, line } = action.payload;
            const { breakpoints } = state;
            if (breakpoints[file] === undefined) {
                breakpoints[file] = [];
            }
            const index = breakpoints[file].indexOf(line);
            if (index < 0) {
                breakpoints[file].push(line);
            } else {
                breakpoints[file].splice(index, 1);
            }
            state = {
                ...state,
                breakpoints: {
                    ...breakpoints,
                },
            };
        },
        toggleBlockBreakpoint: (state, action) => {
            const blockId = action.payload;
            const { blockBreakpoints } = state;
            const index = blockBreakpoints.indexOf(blockId);
            if (index < 0) {
                blockBreakpoints.push(blockId);
            } else {
                blockBreakpoints.splice(index, 1);
            }
            state = {
                ...state,
                blockBreakpoints,
            };
        },
        setCurrentBlockBreakpoint: (state, action) => {
            state.currentBlockBreakpoint = action.payload;
        },
        setBlockHighlights: (state, action) => {
            const blockIds = action.payload;
            const ts = Date.now();
            const newBlockHighlights = {};
            for (let i = 0; i < blockIds.length; i++) {
                newBlockHighlights[blockIds[i]] = ts;
            }
            state.blockHighlights = {
                ...state.blockHighlights,
                ...newBlockHighlights,
            };
        },
        setFirmwareUploadState: (state, action) => {
            state.firmwareUploadState = action.payload;
        },
        setShowFirmwareDownload: (state, action) => {
            state.showFirmwareDownload = action.payload;
        },
        setGPIOState: (state, action) => { },
        sendWiegand: (state, action) => { },
        debuggerDeviceStepOver: (state, action) => { },
    },
});

// Action creators are generated for each case reducer function
export const {
    setConnected,
    setDevices,
    setSelectedNetwork,
    clearConsole,
    addToConsole,
    setConsole,
    setDevice,
    debuggerInit,
    debuggerClose,
    debuggerRefresh,
    debuggerDeviceBuzz,
    debuggerDeviceReboot,
    debuggerDevicePause,
    debuggerDeviceRestartDebug,
    debuggerVariablesGetAll,
    debuggerVariableGet,
    debuggerVariableSet,
    debuggerDeviceStartDebug,
    debuggerStop,
    debuggerDeviceLogin,
    debuggerSetPassword,
    debuggerUploadApplication,
    debuggerUploadFirmware,
    debuggerSetBinary,
    debuggerTaskStop,
    debuggerDownloadRelease,
    debuggerDownloadTcu,
    debuggerSaveTcu,
    debuggerUploadRelease,
    debuggerDownloadTcuFromServer,
    deviceDashboardProxyHttpRequest,
    setDeviceDashboardRequests,
    clearDeviceDashboardRequests,
    setBreakpoints,
    toggleBreakpoint,
    toggleBlockBreakpoint,
    setCurrentBlockBreakpoint,
    setBlockHighlights,
    setFirmwareUploadState,
    setShowFirmwareDownload,
    debuggerSaveFirmware,
    debuggerSetSerialPort,
    debuggerAttachSerial,
    debuggerDetachSerial,
    debuggerSetSerialBaud,
    setUploadMethod,
    setGPIOState,
    sendWiegand,
    setRunMode,
    simulatorSendEvent,
    debuggerDeviceStepOver,
} = debugSlice.actions;

export default debugSlice.reducer;
